import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=22ce063a&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=22ce063a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce063a",
  null
  
)

export default component.exports